import { I as t } from "../../iconLoader.gen-CjadCA3f.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
